import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  AiOutlineLock,
  AiOutlineEye,
  AiOutlineEyeInvisible,
} from "react-icons/ai";
import { apiPostPut, apiPostPutPublic } from "../../api/api_methods";
import { useStores } from "../../store";
import AlertPopup from "./alertPopup";

import {
  AiOutlineArrowLeft,
  AiOutlineMail,
  AiOutlineWarning,
} from "react-icons/ai";
import Loader from "../reusble_components/loader";
export default function ResetForm() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { PopupStore } = useStores();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setloading] = useState(false);
  const [showTermAndConditions, setshowTermAndConditions] = useState(false);
  const [register, setRegister] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [warn, setWarn] = useState(false);

  const [newUserDetails, setnewUserDetails] = useState({});
  const [rcode, setRcode] = useState("");

  return (
    <>
      <AlertPopup />
      <div className="flex flex-col items-center justify-start md:justify-end mx-auto md:w-full lg:w-full w-[100%] h-screen bg-[#F8F2E9] gil-reg">
        <Loader loader={loading} />

        <div className="flex flex-col items-center justify-center h-screen bg-[#F8F2E9]">
          <label className="text-lg flex items-center gap-3 mb-8 w-[300px]">
            <AiOutlineArrowLeft
              className="text-xl opacity-80 cursor-pointer"
              onClick={() => {
                navigate("/");
              }}
            />
            Reset Password
          </label>

          {/* Check for token and display appropriate form */}
          {!token ? (
            <form
              className="flex flex-col gap-5 w-[300px]"
              onSubmit={async (e) => {
                e.preventDefault();
                setloading(true);
                const response = await apiPostPutPublic(
                  { email: e.target.email.value },
                  "/user/forgot-password",
                  "POST"
                );
                setloading(false);
                if (response.status === 200) {
                  PopupStore.setTitle(response.body?.title);
                  PopupStore.setMessage(response.body?.message);
                  PopupStore.setAlert(true);
                  // alert(response.body.data.message);
                  // navigate("/");
                } else {
                  PopupStore.setTitle(response.body.title);
                  PopupStore.setMessage(response.body.message);
                  PopupStore.setAlert(true);

                  // alert(response.body.message);
                }
              }}
            >
              <h1 className="w-50 h-3 ml-2 font- mt-auto ">
                {" "}
                Enter your email{" "}
              </h1>
              <div className="flex items-center border-2 border-opacity-75 bg-white px-3 h-12 rounded-lg">
                <AiOutlineMail className="text-2xl opacity-80 " />
                <input
                  type="text"
                  name="email"
                  className=" bg-transparent px-2 py-2 w-full outline-none rounded-lg placeholder:text-black placeholder:opacity-80  tracking-[3px] "
                  placeholder="Enter your email"
                />
              </div>

              <button
                type="submit"
                className="gil-reg text-lg bg-primary text-white px-4 py-2 rounded-md shadow-md hover:shadow-lg focus:outline-none w-full"
              >
                Reset Password
              </button>
            </form>
          ) : (
            <form
              className="flex flex-col items-center gap-5 w-[300px]"
              onSubmit={async (e) => {
                e.preventDefault();
                setloading(true);
                if (warn) {
                  setloading(false);
                  return;
                }
                const response = await apiPostPut(
                  { password: e.target.password.value },
                  `/user/reset-password/${token}`,
                  "POST"
                );
                if (response.status === 200) {
                  alert(response.body.data.message);
                  navigate("/");
                } else {
                  alert(response.body.message);
                }
              }}
            >
              {/* Password Input */}
              <div className="flex items-center border-2 border-opacity-75 px-3 h-12 rounded-md w-full">
                <AiOutlineLock className="text-2xl opacity-80" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="bg-transparent w-full px-1 py-1 outline-none rounded-lg placeholder:text-black placeholder:opacity-80 tracking-[2px]"
                  placeholder="Enter your password"
                />
                {showPassword ? (
                  <AiOutlineEyeInvisible
                    onClick={() => setShowPassword(false)}
                    className="text-xl opacity-50 cursor-pointer"
                  />
                ) : (
                  <AiOutlineEye
                    onClick={() => setShowPassword(true)}
                    className="text-xl opacity-50 cursor-pointer"
                  />
                )}
              </div>

              {/* Confirm Password Input */}
              <div className="flex items-center border-2 border-opacity-75 px-3 h-12 rounded-md w-full">
                <AiOutlineLock className="text-2xl opacity-80" />
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  className="bg-transparent px-1 w-full py-1 outline-none rounded-lg placeholder:text-black placeholder:opacity-80 tracking-[2px]"
                  placeholder="Re-enter your password"
                  onChange={(e) => {
                    if (e.target.value !== e.target.form.password.value) {
                      setWarn(true);
                    } else {
                      setWarn(false);
                    }
                  }}
                />
                {showConfirmPassword ? (
                  <AiOutlineEyeInvisible
                    onClick={() => setShowConfirmPassword(false)}
                    className="text-xl opacity-50 cursor-pointer"
                  />
                ) : (
                  <AiOutlineEye
                    onClick={() => setShowConfirmPassword(true)}
                    className="text-xl opacity-50 cursor-pointer"
                  />
                )}
              </div>

              {/* Password Mismatch Warning */}
              {warn && (
                <span className="flex items-center gap-2">
                  <AiOutlineWarning className="text-red-500 text-[50px]" /> Your
                  password and confirmation password should match.
                </span>
              )}

              <button
                type="submit"
                className="gil-reg text-lg bg-primary text-white px-4 py-2 rounded-md shadow-md hover:shadow-lg focus:outline-none w-full"
              >
                Reset Password
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
